import { css } from '@emotion/css'
import getThemeColors from '../../../themes'

const styles = {
  wrapper: css({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  }),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.light,
  })
}

export const wrapperSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        width: 14,
        height: 14,
      })

    case 'small':
      return css({
        width: 16,
        height: 16,
      })

    case 'medium':
      return css({
        width: 20,
        height: 20,
      })

    case 'large':
      return css({
        width: 24,
        height: 24,
      })

    default:
      return css({
        width: 18,
        height: 18,
      })
  }
}

export const iconColor = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}

export const iconSize = (size, withBackground) => {
  switch (size) {
    case 'extraSmall':
      return withBackground ? 10 : 14

    case 'small':
      return withBackground ? 12 : 16

    case 'medium':
      return withBackground ? 14 : 20

    case 'large':
      return withBackground ? 16 : 24

    default:
      return withBackground ? 12 : 18
  }
}
